import React from 'react';
import './StepProgress.css';

const StepProgress = ({ currentStep }) => {
    const steps = [
        'Course Information',
        'Course Options',
        'Course Content',
        'Additional Information',
    ];

    return (
        <div className="step-progress">
            {steps.map((step, index) => (
                <div key={index} className={`step-item ${currentStep > index ? 'active' : ''} `}>
                    <div className="step-label">{step} </div>
                    <div className="ms-5 step-circle">
                        {currentStep >= index ? (
                            <i className="fas fa-check-circle"></i>
                        ) : (
                            <i className="far fa-circle"></i>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StepProgress;
